export default __webpack_public_path__ + "static/media/LO09.067f62b4.mp3";